var cifAe = ["301 151", "<g fill='none'><path fill='#009E49' d='M.5.5h300v50H.5z'/><path fill='#FFF' d='M.5 50.5h300v50H.5z'/><path fill='#000' d='M.5 100.5h300v50H.5z'/><path fill='#CE1126' d='M.5.5h75v150H.5z'/></g>"];

export { cifAe };

